module.exports = __webpack_public_path__ + "media/mypage/images/menu/info-1775dbfe82e5063b42ed10f7acb90b4f.png";